<template>
  <div class="filter-district">
    <InputFilter
      v-model="input"
      :value="input"
      :placeholder="$t('placeholder.district')"
      :is-disable="isInputActive"
      :default-store-value="[]"
      :is-readonly-now="show"
      action-name="search/CLEAR_DISTRICTS"
      @clicked="openModal"
    />
    <el-dialog
      :visible.sync="show"
      width="300px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :center="true"
      :show-close="false"
      :lock-scroll="true"
      class="filter-modal-wrapper"
    >
      <ModalDistrict @clicked="chooseDistrict" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputFilter from '~/components/Common/InputFilter'
import ModalDistrict from '~/components/Search/Modals/District'

export default {
  name: 'District',
  components: {
    ModalDistrict,
    InputFilter
  },
  data() {
    return {
      show: false,
      input: ''
    }
  },
  computed: {
    ...mapGetters({
      getDistrict: 'search/searchDistrict',
      getMicroDistrict: 'search/searchMicroDistrict',
      searchSubway: 'search/searchSubway',
      loadedDistricts: 'search/getCityDistricts',
      cityDistrictsList: 'search/getCityDistricts'
    }),
    isInputActive() {
      return !!this.searchSubway.length
    }
  },
  watch: {
    getDistrict() {
      this.input = this.districtString()
    },
    getMicroDistrict() {
      this.input = this.districtString()
    },
    cityDistrictsList: {
      immediate: true,
      handler(val) {
        if (val.length) {
          this.fillDistrictsNames()
        }
      }
    }
  },
  mounted() {
    this.input = this.districtString()
  },
  methods: {
    ...mapActions({
      loadDistricts: 'search/LOAD_CITY_DISTRICTS',
      fillDistrictsNames: 'search/FILL_DISTRICTS_NAMES'
    }),
    chooseDistrict() {
      this.show = false
    },
    districtString() {
      return [
        ...this.getDistrict?.map((item) => item.title),
        ...this.getMicroDistrict?.map((item) => item.title)
      ].join(', ')
    },
    openModal() {
      this.show = true
      if (!this.loadedDistricts.length) {
        this.loadDistricts()
      }
    }
  }
}
</script>

<style scoped></style>
